<div title="{{text}}">{{text}}</div>